import useAsyncData from "../../../hooks/use-async-data";
import planEntryService from "../plan-entry.service";
import PlanEntryFinishedList from "./plan-entry-finished-list";
import PlanEntryFinishedListParams from "./plan-entry-finished-list-params";

const usePlanEntryFinishedList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<PlanEntryFinishedList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: PlanEntryFinishedListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderFinishedList = await planEntryService.getFinishedList(
        params,
        signal,
      );

      setData(cargoOrderFinishedList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default usePlanEntryFinishedList;
